import types from '../actionTypes';

const initialState = {
	id: 'task-list',
	tasks: [],
	pytania: [],
};

function tasksReducer(state = initialState, action) {
	switch (action.type) {
		case types.SET_TASKLIST:
			return {
				...state,
				tasks: action.tasks,
			};
		default:
			return state;
	}
}

export default tasksReducer;
